import React from 'react';
import { Typography, Box, ListItem, ListItemText } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import i18next from 'i18next';
import {
  StartStepContainer,
  InfoCard,
  StartButton,
  StyledList,
  SectionLabel,
  FileIconWrapper,
  StatusChip,
} from './styles';
import './i18n';

interface Props {
  onStart: () => void;
  procedureName: string;
  requiredFiles: string[];
}

const ProcedureStartStep: React.FC<Props> = ({ onStart, procedureName, requiredFiles }) => {
  return (
    <StartStepContainer>
      <Typography variant="h4" fontWeight={800} letterSpacing="-0.02em" gutterBottom>
        {procedureName}
      </Typography>

      <Typography variant="body1" color="text.secondary" fontWeight={300} marginBottom={4}>
        {i18next.t<string>(
          'PROCEDURES:START_SUBTITLE',
          'Completá este proceso en simples pasos. Asegurate de tener todo listo antes de empezar.',
        )}
      </Typography>

      <InfoCard elevation={0}>
        <StyledList>
          <SectionLabel variant="overline">
            {i18next.t<string>('PROCEDURES:FILES_REQUIRED_TITLE', 'Documentación a subir')}
          </SectionLabel>

          {requiredFiles.map((file) => {
            const isMandatory = file.includes('[OBLIGATORIO]');
            const cleanText = file.replace(/^\[.*?\]\s*/, '');
            const [title, description] = cleanText.split(': ');

            return (
              <ListItem disableGutters sx={{ alignItems: 'flex-start', mb: 2 }}>
                <FileIconWrapper $isMandatory={isMandatory}>
                  <DescriptionOutlined />
                </FileIconWrapper>

                <ListItemText
                  primary={
                    <Box component="span" display="flex" alignItems="center">
                      {title}
                      <StatusChip $isMandatory={isMandatory}>
                        {isMandatory ? 'Obligatorio' : 'Opcional'}
                      </StatusChip>
                    </Box>
                  }
                  secondary={description}
                  primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 700 } }}
                  secondaryTypographyProps={{
                    variant: 'caption',
                    sx: { display: 'block', mt: 0.5 },
                  }}
                />
              </ListItem>
            );
          })}
        </StyledList>
      </InfoCard>

      <Box display="flex" justifyContent="center">
        <StartButton variant="contained" onClick={onStart}>
          {i18next.t<string>('PROCEDURES:START_BUTTON', 'Entendido, comenzar')}
        </StartButton>
      </Box>
    </StartStepContainer>
  );
};

export default ProcedureStartStep;
